var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.911 6.284l-.057.07l-4 4a.5.5 0 0 1-.765-.638l.057-.07L4.793 6L1.146 2.354a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057l.07.057l4 4a.5.5 0 0 1 .057.638m5 0l-.057.07l-4 4a.5.5 0 0 1-.765-.638l.057-.07L9.793 6L6.146 2.354a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057l.07.057l4 4a.5.5 0 0 1 .057.638"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleRight);
export default __webpack_public_path__ + "static/media/chevron-double-right.bf6661a20f98991193a727a47d2245af.svg";
export { ForwardRef as ReactComponent };